/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={MULTIPLIER:"multiplier",ABSOLUTE:"absolute-value"};export{e as IdealEdgeLengthTypeOptions};
